import {
  Box,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { ContatoType } from "models/contato_type";
import { PessoaType } from "models/person_type";
import { Project } from "models/project_type";
import { UsuarioModel } from "models/user_model";
import ProjectHeader from "./Header";
import TimeLineProject from "./TimeLine";

interface IProjectForm {
  showModal: (show: boolean, item: Project) => void;
  show: boolean;
  accountSelected: Project;
  loading: boolean;
  contatoAgencia: ContatoType;
  contatoCliente: ContatoType;
  users: UsuarioModel[];
  clients: PessoaType[];
}

const ProjectForm = ({
  showModal,
  show,
  accountSelected,
  loading,
  contatoAgencia,
  contatoCliente,
  users,
  clients
}: IProjectForm) => {

  return (
    <Box>
      <Box>
        <Box>
        </Box>
        <ProjectHeader
          accountSelected={accountSelected}
          contatoAgencia={contatoAgencia}
          contatoCliente={contatoCliente}
          users={users}
        />
        <TimeLineProject
          accountSelected={accountSelected}
          users={users}
          contatoAgencia={contatoAgencia}
          contatoCliente={contatoCliente}
          clients={clients}
        />
      </Box>
    </Box>
  );
};
export default ProjectForm;
